import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setNavigationTitle } from '../../Store/Actions/navigationHeaderActions';
import useGlobals from '../../Hooks/useGlobals';

interface AdminBoxHeadlineProps {
    headLine?: string;
    subLine?: string;
}

function AdminBoxHeadline({ headLine, subLine }: AdminBoxHeadlineProps) {
    const dispatch = useDispatch();
    const { currentURL } = useGlobals();

    useEffect(() => {
        dispatch(setNavigationTitle(`${headLine ?? ''}${subLine ? ' - ' + subLine : ''}`));
    }, [headLine, subLine, dispatch, currentURL]);

    return null;
}

export default AdminBoxHeadline;
